/**
 * User supplied button for the navbar
 */

import * as DOMUtils from "../ui/utils/dom-utils.js"

const CustomButton = function (parent, browser, b) {
    const button = DOMUtils.div({class: 'igv-navbar-icon-button'})
    button.style.backgroundImage = `url("data:image/svg+xml,${ encodeURIComponent(b.icon) }")`
    button.style.display = "flex"
    parent.append(button)
    button.textContent = b.label
    button.addEventListener('click', (event) => b.callback(browser, event))
    button.addEventListener('mouseover', () => {
        button.style.backgroundImage = `url("data:image/svg+xml,${ encodeURIComponent(b.hoverIcon) }")`
    })
    button.addEventListener('mouseout', () => {
        button.style.backgroundImage = `url("data:image/svg+xml,${ encodeURIComponent(b.icon) }")`
    })
}

export default CustomButton
